// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__16yGL","inner":"Footer_inner__1varB","nextIcon":"Footer_nextIcon__1Q_W0","innerLeft":"Footer_innerLeft__1TXAg"};